import React from "react";
import { useSiteContent } from "../content/SiteContentContext.jsx";
import { resolveImage } from "../utils/resolveImage";
import { RichText } from "../utils/richText.jsx";
import Heading from "./common/Heading.jsx";

const Testimonal = () => {
  const { testimonal } = useSiteContent();
  return (
    <>
      <section className="testimonal py-20">
        <div className="mx-auto max-w-[85%]">
          <Heading subtitle="Testimonios" title="Nuestras historias de éxito" />

          <div className="content grid gap-[30px] md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3">
            {testimonal.map((val, index) => (
              <div className="items p-[30px] shadow-lg bg-white" key={index}>
                <div className="box flex">
                  <div className="relative">
                    <img
                      className="w-[80px] h-[80px] rounded-full"
                      src={resolveImage(val.imageIcon)}
                      alt={`Testimonial ${index + 1}`}
                    />
                    <i className="fa fa-quote-left icon absolute bottom-0 left-[50px] bg-primary text-white"></i>
                  </div>
                  <div className="m-[15px]">
                    <h2 className="text-base mb-1">{val.name}</h2>
                    <span className="text-primary">{val.post}</span>
                  </div>
                </div>
                <RichText html={val.desc} className="text-gray-500" />
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Testimonal;
